export const OFFER_KINDS = ['QUOTE', 'PROFORMA', 'DELIVERY'] as const;
export const OFFER_STATUSES = ['OPEN', 'CONVERTED', 'CANCELLED'] as const;

export type OfferKind = (typeof OFFER_KINDS)[number];
export type OfferStatus = (typeof OFFER_STATUSES)[number];

export type OfferLine = {
  key: string;
  item: number;
  item_desc: string;
  item_code?: string;
  planned_qty: number;
  quantity: number;
  amount: number;
};

export type OfferRow = {
  batch: string;
  reference: string;
  date: string;
  valid_until?: string | null;
  kind: OfferKind | string;
  status: OfferStatus | string;
  client?: string;
  client_id?: number;
  agent?: string;
  agent_id?: number | null;
  depot?: string;
  depot_id?: number | null;
  planned_amount?: number;
  invoiced_amount?: number;
  invoice?: string | null;
  description?: string;
};

export const offerKindI18nKey = (kind?: string) =>
  `common:offer.kinds.${String(kind || 'QUOTE').toLowerCase()}`;

export const offerStatusI18nKey = (status?: string) =>
  `common:offer.statuses.${String(status || 'OPEN').toLowerCase()}`;
